import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import { Grid, Table, TableHeaderRow } from '@devexpress/dx-react-grid-material-ui';
import { TableComponent } from '../NRReactGridCustomComponents/TableComponent/TableComponent';
import { CellComponent } from '../NRReactGridCustomComponents/CellComponent/CellComponent';

const DEFAULT_PAPER_VARIANT = 'elevation';

const PrintableHeaderCell = props => (
  <TableHeaderRow.Cell
    {...props}
    style={{
      ...props.style,
      textAlign: 'left'
    }}
  />
);

function NRReactGridPrintable({
  rows = [],
  columns = [],
  columnExtensions = [],
  providersArray = [],
  renderersArray = [],
  variant = DEFAULT_PAPER_VARIANT
}) {
  return (
    <Paper
      variant={variant}
      {...(variant === 'elevation' && { elevation: 0 })}
      sx={{
        p: 1.5
      }}
    >
      <Grid rows={rows} columns={columns}>
        {providersArray}
        <Table columnExtensions={columnExtensions} tableComponent={TableComponent} cellComponent={CellComponent} />
        <TableHeaderRow cellComponent={PrintableHeaderCell} />
        {renderersArray}
      </Grid>
    </Paper>
  );
}

NRReactGridPrintable.propTypes = {
  rows: PropTypes.array,
  columns: PropTypes.array,
  columnExtensions: PropTypes.array,
  providersArray: PropTypes.array,
  renderersArray: PropTypes.array,
  variant: PropTypes.oneOf(['elevation', 'outlined'])
};

export default NRReactGridPrintable;
